import React, { useState, useMemo, useEffect } from 'react';
import { Button, Menu, MenuItem, Checkbox, FormControlLabel } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

interface DropdownWithCheckboxesProps {
  options: string[];
  selected: string[];
  setSelected: (selected: string[]) => void;
}

const DropdownWithCheckboxes: React.FC<DropdownWithCheckboxesProps> = ({ options, selected, setSelected }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const [checkedItems, setCheckedItems] = useState<Record<string, boolean>>(
    options.reduce((acc, option) => ({ ...acc, [option]: selected.includes(option) }), {})
  );
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedItems({
      ...checkedItems,
      [event.target.name]: event.target.checked
    });
  };

  const filteredItems = useMemo(() => {
    const selected = Object.keys(checkedItems).filter((key) => checkedItems[key]);
    return selected;
  }, [checkedItems]);

  useEffect(() => {
    setSelected(filteredItems);
  }, [filteredItems]);

  return (
    <div>
      <Button
        variant="contained"
        endIcon={<KeyboardArrowDownIcon />}
        onClick={handleClick}
        sx={{
          border: '2px solid #1976d2', // Adjust the color and width as needed
          borderRadius: '8px',
          fontSize: '12px',
          padding: '3px 10px'
        }}
      >
        {filteredItems && filteredItems.length ? (
          <>
            {filteredItems.map((filter: any, idx: number) => (
              <span key={idx}>
                In {filter}
                {idx < filteredItems.length - 1 && ', '}
              </span>
            ))}
          </>
        ) : (
          <span>Filter</span>
        )}
      </Button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{
          '& .MuiMenuItem-root': {
            fontSize: '0.6rem' // Smaller font size for MenuItem
          }
        }}
      >
        {options.map((option) => (
          <MenuItem key={option}>
            <FormControlLabel
              control={<Checkbox checked={checkedItems[option]} onChange={handleCheckboxChange} name={option} />}
              label={option}
              sx={{
                '& .MuiSvgIcon-root': { fontSize: '1.1rem' },
                '& .MuiFormControlLabel-label': { fontSize: '0.875rem' },
                marginLeft: 0
              }}
            />
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default DropdownWithCheckboxes;
